import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface WhatsAppState {
  // UI State
  activeJid: string | null;
  isQRModalOpen: boolean;
  composerText: string;
  chatFilter: 'all' | 'unread' | 'archived';

  // Actions
  setActiveJid: (jid: string | null) => void;
  setQRModalOpen: (open: boolean) => void;
  setComposerText: (text: string) => void;
  setChatFilter: (filter: 'all' | 'unread' | 'archived') => void;
}

export const useWhatsAppStore = create<WhatsAppState>()(
  persist(
    immer((set) => ({
      // Initial state
      activeJid: null,
      isQRModalOpen: false,
      composerText: '',
      chatFilter: 'all',

      // Actions
      setActiveJid: (jid) => set((state) => { state.activeJid = jid; }),
      setQRModalOpen: (open) => set((state) => { state.isQRModalOpen = open; }),
      setComposerText: (text) => set((state) => { state.composerText = text; }),
      setChatFilter: (filter) => set((state) => { state.chatFilter = filter; }),
    })),
    {
      name: 'whatsapp-ui-state',
      partialize: (state) => ({
        // Only persist these fields
        chatFilter: state.chatFilter,
      }),
    }
  )
);
